import React from 'react';
import { Info, X } from 'lucide-react';

/**
 * SeedDataNotice — info bar above a panel form when pre-filled from a prior step.
 * Shows "Pre-filled from [pillar label] — you can adjust any values" with a Clear button.
 */
const SeedDataNotice = ({ fromPillar, onClear }) => {
  if (!fromPillar) return null;

  return (
    <div className="mb-4 border border-[#3832e3]/30 bg-[#3832e3]/5 px-4 py-2.5 flex items-center gap-2 text-xs">
      <Info className="w-3.5 h-3.5 text-[#3832e3] flex-shrink-0" />
      <span className="font-sans text-zinc-700 flex-1">
        Pre-filled from <span className="font-medium text-black">{fromPillar.label}</span> — you can adjust any values
      </span>
      {onClear && (
        <button
          onClick={onClear}
          className="flex items-center gap-1 font-mono text-[10px] uppercase tracking-wider text-zinc-500 hover:text-black transition-colors"
        >
          <X className="w-3 h-3" />
          Clear
        </button>
      )}
    </div>
  );
};

export default SeedDataNotice;
